import React, { useState } from 'react';
import './LandingPage.css';

const VideoPlayerPage = ({ navigateTo, video }) => {
  const [showTranscript, setShowTranscript] = useState(false);

  // Sample transcript for demo purposes
  const transcript = [
    { time: "0:00", text: "Welcome to another episode of DeFi Made Simple!" },
    { time: "0:05", text: "Today we're diving into Uniswap v4 hooks and why they're revolutionary." },
    { time: "0:15", text: "Hooks allow developers to customize pool behavior at key lifecycle events." },
    { time: "0:25", text: "This means we can now add features like dynamic fees, MEV protection, and custom oracles." },
    { time: "0:35", text: "Let's break down how this works with a simple example..." },
    { time: "0:45", text: "Thanks for watching! Don't forget to subscribe for more DeFi content." }
  ];

  // Related videos
  const relatedVideos = [
    {
      id: 10,
      title: "Uniswap v3 vs v4: What Changed?",
      views: "9.1K",
      timestamp: "3 days ago",
      platform: "youtube"
    },
    {
      id: 11,
      title: "Building Your First Hook",
      views: "5.3K",
      timestamp: "1 week ago",
      platform: "tiktok"
    },
    {
      id: 12,
      title: "Hook Security Best Practices",
      views: "7.8K",
      timestamp: "2 weeks ago",
      platform: "youtube"
    }
  ];

  if (!video) {
    return (
      <div className="app">
        <header>
          <div className="container header-content">
            <h1 className="logo" onClick={() => navigateTo('home')} style={{cursor: 'pointer'}}>
              <span className="green">internet</span>
              <span className="purple">money</span>
              <span className="yellow">is</span>
              <span className="blue">serious</span>
              <span className="pink">.business</span>
            </h1>
          </div>
        </header>
        <div className="container" style={{padding: '2rem 0', textAlign: 'center'}}>
          <h2>Video not found</h2>
          <p>The video you're looking for doesn't exist.</p>
          <button 
            onClick={() => navigateTo('home')} 
            className="cta-btn"
            style={{marginTop: '1rem'}}
          >
            Back to Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      {/* Header */}
      <header>
        <div className="container header-content">
          <h1 className="logo" onClick={() => navigateTo('home')} style={{cursor: 'pointer'}}>
            <span className="green">internet</span>
            <span className="purple">money</span>
            <span className="yellow">is</span>
            <span className="blue">serious</span>
            <span className="pink">.business</span>
          </h1>
          
          <nav className="main-nav">
            <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('home'); }} className="nav-link">Home</a>
            <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('videos'); }} className="nav-link">Videos</a>
            <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('learn'); }} className="nav-link">Learn</a>
            <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('about'); }} className="nav-link">About</a>
          </nav>
          
          <button className="subscribe-btn" onClick={() => navigateTo('home')}>
            Subscribe
          </button>
        </div>
      </header>

      {/* Video Player Page Content */}
      <section className="page-content">
        <div className="container">
          <div style={{marginTop: '2rem'}}>
            {/* Back Button */}
            <button 
              onClick={() => navigateTo('videos')} 
              style={{
                padding: '0.5rem 1rem',
                backgroundColor: '#f3f4f6',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                cursor: 'pointer',
                marginBottom: '1rem'
              }}
            >
              ← Back to Videos
            </button>

            <div style={{display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '2rem'}}>
              {/* Main Video Area */}
              <div>
                {/* Video Player Placeholder */}
                <div style={{
                  width: '100%',
                  aspectRatio: '16/9',
                  backgroundColor: '#000',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                  marginBottom: '1rem'
                }}>
                  <div style={{
                    color: 'white',
                    textAlign: 'center'
                  }}>
                    <div style={{fontSize: '3rem', marginBottom: '1rem'}}>▶</div>
                    <p>Click to watch on {video.platform === 'youtube' ? 'YouTube' : 'TikTok'}</p>
                    <a 
                      href={video.url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      style={{
                        color: '#6366f1',
                        textDecoration: 'underline',
                        fontSize: '1.1rem'
                      }}
                    >
                      Watch Now
                    </a>
                  </div>
                  
                  {/* Platform Badge */}
                  <div style={{
                    position: 'absolute',
                    top: '1rem',
                    right: '1rem',
                    padding: '0.5rem 1rem',
                    backgroundColor: video.platform === 'youtube' ? '#ff0000' : '#000000',
                    color: 'white',
                    borderRadius: '20px',
                    fontSize: '0.9rem'
                  }}>
                    {video.platform === 'youtube' ? 'YouTube' : 'TikTok'}
                  </div>
                </div>

                {/* Video Info */}
                <div>
                  <h1 style={{margin: '0 0 1rem 0'}}>{video.title}</h1>
                  <div style={{display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem'}}>
                    <span style={{color: '#666'}}>{video.views} views</span>
                    <span style={{color: '#666'}}>•</span>
                    <span style={{color: '#666'}}>{video.timestamp}</span>
                  </div>
                  <p style={{lineHeight: '1.6', color: '#555'}}>
                    {video.description}
                  </p>
                </div>

                {/* Action Buttons */}
                <div style={{
                  display: 'flex',
                  gap: '1rem',
                  margin: '2rem 0',
                  flexWrap: 'wrap'
                }}>
                  <button style={{
                    padding: '0.75rem 1.5rem',
                    backgroundColor: '#6366f1',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer'
                  }}>
                    👍 Like
                  </button>
                  <button style={{
                    padding: '0.75rem 1.5rem',
                    backgroundColor: '#f3f4f6',
                    color: '#374151',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    cursor: 'pointer'
                  }}>
                    💾 Save
                  </button>
                  <button style={{
                    padding: '0.75rem 1.5rem',
                    backgroundColor: '#f3f4f6',
                    color: '#374151',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    cursor: 'pointer'
                  }}>
                    📤 Share
                  </button>
                  <button 
                    onClick={() => setShowTranscript(!showTranscript)}
                    style={{
                      padding: '0.75rem 1.5rem',
                      backgroundColor: showTranscript ? '#6366f1' : '#f3f4f6',
                      color: showTranscript ? 'white' : '#374151',
                      border: '1px solid #d1d5db',
                      borderRadius: '6px',
                      cursor: 'pointer'
                    }}
                  >
                    📝 Transcript
                  </button>
                </div>

                {/* Transcript */}
                {showTranscript && (
                  <div style={{
                    backgroundColor: '#f8fafc',
                    padding: '1.5rem',
                    borderRadius: '8px',
                    marginTop: '1rem'
                  }}>
                    <h3>Video Transcript</h3>
                    <div style={{marginTop: '1rem'}}>
                      {transcript.map((line, index) => (
                        <div key={index} style={{
                          display: 'flex',
                          marginBottom: '0.5rem',
                          fontSize: '0.95rem'
                        }}>
                          <span style={{
                            fontWeight: 'bold',
                            color: '#6366f1',
                            marginRight: '1rem',
                            minWidth: '3rem'
                          }}>
                            {line.time}
                          </span>
                          <span>{line.text}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Sidebar */}
              <div>
                <h3>Related Videos</h3>
                <div style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
                  {relatedVideos.map(relatedVideo => (
                    <div 
                      key={relatedVideo.id}
                      onClick={() => navigateTo('videos')}
                      style={{
                        display: 'flex',
                        gap: '1rem',
                        padding: '1rem',
                        border: '1px solid #e5e7eb',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        transition: 'all 0.2s'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.borderColor = '#6366f1';
                        e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.borderColor = '#e5e7eb';
                        e.target.style.boxShadow = 'none';
                      }}
                    >
                      <div style={{
                        width: '80px',
                        height: '45px',
                        backgroundColor: '#f3f4f6',
                        borderRadius: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1.2rem'
                      }}>
                        ▶
                      </div>
                      <div style={{flex: '1'}}>
                        <h4 style={{
                          margin: '0 0 0.5rem 0',
                          fontSize: '0.9rem',
                          lineHeight: '1.3'
                        }}>
                          {relatedVideo.title}
                        </h4>
                        <div style={{fontSize: '0.8rem', color: '#666'}}>
                          <div>{relatedVideo.views} views</div>
                          <div>{relatedVideo.timestamp}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Subscribe Box */}
                <div style={{
                  backgroundColor: '#6366f1',
                  color: 'white',
                  padding: '1.5rem',
                  borderRadius: '8px',
                  marginTop: '2rem',
                  textAlign: 'center'
                }}>
                  <h4 style={{margin: '0 0 0.5rem 0'}}>Like this content?</h4>
                  <p style={{margin: '0 0 1rem 0', fontSize: '0.9rem'}}>
                    Subscribe to get notified when we post new videos
                  </p>
                  <button style={{
                    backgroundColor: 'white',
                    color: '#6366f1',
                    border: 'none',
                    padding: '0.75rem 1.5rem',
                    borderRadius: '6px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    width: '100%'
                  }}>
                    Subscribe Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={{marginTop: '3rem'}}>
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <h2 className="logo">
                <span className="green">internet</span>
                <span className="purple">money</span>
                <span className="yellow">is</span>
                <span className="blue">serious</span>
                <span className="pink">.business</span>
              </h2>
              <p>DeFi education in bite-sized videos</p>
            </div>
            
            <div className="footer-links">
              <a href="https://youtube.com/@internetmoneyisserious" target="_blank" rel="noopener noreferrer">YouTube</a>
              <a href="https://tiktok.com/@internetmoneyisserious" target="_blank" rel="noopener noreferrer">TikTok</a>
              <a href="https://twitter.com/imseriousbiz" target="_blank" rel="noopener noreferrer">Twitter</a>
              <a href="https://discord.gg/defi" target="_blank" rel="noopener noreferrer">Discord</a>
              <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('about'); }}>Contact</a>
            </div>
          </div>
          
          <div className="copyright">
            &copy; {new Date().getFullYear()} internetmoneyisserious.business | Not financial advice
          </div>
        </div>
      </footer>
    </div>
  );
};

export default VideoPlayerPage;